import { combineReducers } from 'redux'
import app_token from './app_token'
import plan from './plan'
import risk from './risk'
import reset_password from './password/reset'
import change_password from './password/change'
import control from './control'
import tags from './tags'
import language from './language'
import user from './user'
import plan_permission from './plan_permission'
import instance from './instance'
import library_control from './library_control'
import library_control_review from './library_control_review'
import translations from './translations'
import snackbar from './snackbar'

const RiskPlanningApp = combineReducers({
  app_token,
  plan,
  risk,
  reset_password,
  change_password,
  control,
  tags,
  language,
  user,
  plan_permission,
  instance,
  library_control,
  library_control_review,
  translations,
  snackbar
})

export default RiskPlanningApp



// WEBPACK FOOTER //
// ./src/reducers/index.js